import { IModalContextProps } from './Provider'

export const ModalRoot = ({ component: Component, props, hideModal, isOpen }: IModalContextProps) =>
  Component ? <Component {...props} onRequestClose={hideModal} isOpen={isOpen} /> : null

export default ModalRoot
